import moment from "moment";
import { DatePicker, Box } from "orcs-design-system";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import getInputLabel from "src/util/getInputLabel";
import { DEFAULT_DATE_FORMAT, READABLE_DATE_FORMAT } from "src/consts/global";

const TagAttributeDateInput = ({
  id,
  name,
  onDateChange,
  value,
  label,
  displayFormat = DEFAULT_DATE_FORMAT,
  placeholder,
  invalid,
  mandatory,
  focus,
}) => {
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (focus) {
      setFocused(true);
    }
  }, [focus]);

  // Use displayFormat for parsing/formatting (maintains compatibility)
  const parseFormat = displayFormat;

  const handleDateChange = (selectedDate) => {
    onDateChange(selectedDate && selectedDate.format(parseFormat));
  };

  return (
    <Box>
      <DatePicker
        single
        id={id}
        name={name}
        date={value && moment(value, parseFormat)}
        focused={focused}
        placeholder={placeholder}
        onDateChange={handleDateChange}
        onFocusChange={(el) => {
          setFocused(el.focused);
        }}
        label={getInputLabel(label, invalid)}
        invalid={invalid}
        required={mandatory}
        numberOfMonths={1}
        daySize={31}
        displayFormat={READABLE_DATE_FORMAT}
        readOnly
        width="100%"
        zIndex="12"
      />
    </Box>
  );
};

TagAttributeDateInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  displayFormat: PropTypes.string,
  placeholder: PropTypes.string,
  onDateChange: PropTypes.func,
  invalid: PropTypes.bool,
  mandatory: PropTypes.bool,
  focus: PropTypes.bool,
};

export default TagAttributeDateInput;
